<template>
  <BaseCard
    :result="{
      orgName: searchResult.secondary_organization.name,
      orgLink: searchResult.link,
      tagName: $t(`search.links.tagName`),
      tagLink: '',
    }"
    class="link-card result-card"
  >
    <template #preview>
      <div class="preview-fallback">
        <Icon
          name="lucide:link"
          size="24"
        />
      </div>
    </template>
    <template #result-content>
      <a
        :href="searchResult.content.url"
        :target="searchResult.content.opens_in_new_tab ? '_blank' : '_self'"
        class="title"
        >{{ searchResult.name }}</a
      >
      <div class="dates-and-times">
        <div class="link">{{ formattedURL }}</div>
      </div>
    </template>
  </BaseCard>
</template>

<script setup>
import BaseCard from './BaseCard.vue';
import { computed } from 'vue';

const props = defineProps({
  searchResult: {
    type: Object,
    default: () => ({}),
  },
});

const formattedURL = computed(() => {
  const rawUrl = props.searchResult.content.url || '';
  return rawUrl.replace(/^(https?:\/\/)?(www\.)?/, '');
});
</script>

<style scoped>
.link-card {
  --color-blue-500: #1850c1;
  --color-blue-50: #f3f6fc;
  --background-color: var(--color-blue-50);
  --text-color: var(--color-blue-500);
}
.title {
  text-decoration: none;
}
</style>
